import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  Box,
  Select,
  MenuItem,
  OutlinedInput,
  Typography,
  Paper,
  InputAdornment
} from '@mui/material';
import { Chart } from 'react-google-charts';
import { DataGrid, ptBR } from '@mui/x-data-grid';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ButtonMain from '../../../Onboarding/shared/ButtonMain';
import LoaderMain from '../../../Onboarding/shared/LoaderMain';
import useVisaoGeralVopHook from './useVisaoGeralVopHook';

const VisaoGeralVop = ({ filtroDashboard, loadingDashFim, setAlerta }) => {
  const {
    isPending,
    data,
    anos,
    anoSelecionado,
    setAnoSelecionado,
    carregarDashBoard,
    formatarMoeda,
    formatarPorcentagem,
    corValor,
    iconeValor,
    columns,
    rows,
    chartData,
    chartOptions
  } = useVisaoGeralVopHook({ filtroDashboard, loadingDashFim, setAlerta });

  return (
    <Card className="chart-card dashBoardVOPGeral">
      <CardContent className={(isPending ? 'posicao-relativa ' : '') + 'ajuste-spin-chart'}>
        {isPending && <LoaderMain tipoLoader="float" tipoImagem="circulo" />}
        <Grid container justifyContent="space-between">
          <Typography className="font-size-1-1-rem texto-weight-600 texto-cor-principal">
            Visão Geral | Pipe Comercial x VOP x À Realizar
          </Typography>
          <Box className="height-40px flex-box">
            <Select
              className="margin-right-5"
              value={anoSelecionado || ''}
              onChange={e => setAnoSelecionado(e.target.value)}
              input={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <OutlinedInput
                  startAdornment={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <InputAdornment
                      className="flex-box items-centro-verticalmente margin-right-8"
                      position="start"
                    >
                      <DateRangeIcon fontSize="small" />
                    </InputAdornment>
                  }
                />
              }
            >
              {anos.map(ano => (
                <MenuItem key={ano} value={ano}>
                  {ano}
                </MenuItem>
              ))}
            </Select>
            <ButtonMain
              tipoBotao="transparente-com-bordas-principal"
              onClick={carregarDashBoard}
              disabled={!anoSelecionado}
            >
              Filtrar
            </ButtonMain>
          </Box>
        </Grid>

        <Grid container spacing={2} className="margin-top-16">
          <Grid item xs={12} sm={6} md={3}>
            <Paper variant="outlined" className="backGroundTotais">
              <Typography className="font-size-15 texto-cinza-escuro-2">Pipe Comercial (R$)</Typography>
              {data.totais.valorPipeComercialAnual != null ? (
                <Typography className="texto-semi-negrito font-size-18">
                  {formatarMoeda(data.totais.valorPipeComercialAnual)}
                </Typography>
              ) : (
                <Box className="semValor texto-semi-negrito font-size-24"> - - - </Box>
              )}
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Paper variant="outlined" className="backGroundTotais">
              <Typography className="font-size-15 texto-cinza-escuro-2">VOP (R$)</Typography>
              {data.totais.valorVOPAnual != null ? (
                <Typography className="texto-semi-negrito font-size-18">
                  {formatarMoeda(data.totais.valorVOPAnual)}
                </Typography>
              ) : (
                <Box className="semValor texto-semi-negrito font-size-24"> - - - </Box>
              )}
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Paper variant="outlined" className="backGroundTotais">
              <Typography className="font-size-15 texto-cinza-escuro-2">À Realizar (R$)</Typography>
              {data.totais.aRealizarAnual != null ? (
                <Typography className="texto-semi-negrito font-size-18">
                  {formatarMoeda(data.totais.aRealizarAnual)}
                </Typography>
              ) : (
                <Box className="semValor texto-semi-negrito font-size-24"> - - - </Box>
              )}
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Paper variant="outlined" className="backGroundTotais">
              <Typography className="font-size-15 texto-cinza-escuro-2">% Atingimento Global</Typography>
              {data.totais.atingimentoAnual != null ? (
                <Box className="flex-box items-centro-verticalmente">
                  {iconeValor(data.totais.atingimentoAnual)}
                  <Typography
                    className={
                      corValor(data.totais.atingimentoAnual) + ' texto-semi-negrito font-size-18'
                    }
                  >
                    {formatarPorcentagem(data.totais.atingimentoAnual)}
                  </Typography>
                </Box>
              ) : (
                <Box className="semValor texto-semi-negrito font-size-24"> - - - </Box>
              )}
            </Paper>
          </Grid>
        </Grid>

        <Box className="margin-top-32">
          {Object.keys(data.meses).length > 0 && (
            <Chart
              chartType="ComboChart"
              data={chartData}
              options={chartOptions}
              width="100%"
              height="400px"
              chartLanguage="pt-BR"
            />
          )}
        </Box>

        <Box className="overflow-grid margin-top-32">
          {Object.keys(data.meses).length > 0 && (
            <DataGrid
              className="gridVisaoGeralVop"
              autoHeight
              rows={rows}
              columns={columns}
              getRowHeight={() => 'auto'}
              disableColumnMenu
              disableRowSelectionOnClick
              localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
              sortingOrder={['desc', 'asc']}
              hideFooter
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default VisaoGeralVop;
